function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.92 17.18S20.02 1.43 20.3 1.21C21.3.45 22.56 0 23.92 0a5.8 5.8 0 015.88 5.71c0 1.55-.63 2.95-1.66 3.98L14.38 22.5a1.7 1.7 0 01-2.4-.08 1.7 1.7 0 01.07-2.4l13.5-12.57c.48-.43.78-1.05.78-1.74 0-1.29-1.08-2.34-2.41-2.34-.54 0-1.06.13-1.43.46-3.12 2.72-14.12 12.56-17.3 15.9a5.98 5.98 0 00-1.78 4.1 5.61 5.61 0 008.98 4.48c3.2-2.6 15.88-14.5 15.88-14.5a1.7 1.7 0 112.32 2.5s-12.4 11.85-16 14.6A9.02 9.02 0 012.92 17.19z"
});

var SvgIconAttachment = function SvgIconAttachment(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 33"
  }, props), _ref);
};

export default SvgIconAttachment;